module.exports = __webpack_public_path__ + "static/media/some10-product.e9a95790.jpg";